/**
 * Muestra acordeones paginados por categoría en el modal de detalle.
 * Apagado por defecto: el detalle es solo resumen; el análisis fila a fila va en Excel.
 * Reactivar en true si el cliente pide listados en línea de nuevo.
 */
export const PHYSICAL_COUNT_DETAIL_SHOW_INLINE_GROUPS = true;
